//modules
import React, { useRef, useEffect } from 'react';
import { gsap } from "gsap";
import SplitType from 'split-type';
import { CSSRulePlugin } from 'gsap/CSSRulePlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

//styles
import './TableItem.css';

//plugins
gsap.registerPlugin(CSSRulePlugin, ScrollTrigger);

export const TableItem = ({ leftValue, rightTop, rightBottom, className }) => {

    //text animation
    const textRef = useRef([]);

    useEffect(() => {
      const timer = setTimeout(() => {
          if (!textRef.current) return;
  
          const splitTypes = textRef.current;
  
          splitTypes.forEach((char) => {
            const text = new SplitType(char, { types: 'words' });
  
            gsap.fromTo(
              text.words,
              { color: "var(--background-primary)" },
              {
                color: "var(--text-primary)",
                duration: 1.5,
                stagger: 0.02,
                scrollTrigger: {
                  trigger: char,
                  start: 'top 90%',
                  end: 'top 50%',
                  scrub: true,
                  markers: false,
                  toggleActions: 'play play reverse reverse',
                },
              }
            );
          });
      }, 100);
  
      return () => {
        clearTimeout(timer);
        ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
      };
  }, []);

    return(
        <div className={className}>
            <div className="left-text" ref={(el) => (textRef.current[0] = el)}>
                <p> {leftValue} </p>
            </div> 
            <div className="right-content" ref={(el) => (textRef.current[1] = el)}>
                <p className="right-text"> {rightTop} </p>
                {rightBottom && <p className="secondary-text"> {rightBottom} </p>}
            </div> 
        </div>
    )
}